import React from 'react'
// import ReactDOM from 'react-dom'
import {render} from "react-snapshot"
import App from './App'
import "semantic-ui-css/semantic.min.css"
import './vendor/elemental.scss'
import './vendor/sweetalert.scss'
import './index.scss'
import './animate.css'
import './typography.scss'
import './tachyons.css'

// Polyfill
import Promise from 'promise-polyfill'
if (!window.Promise) {
   window.Promise = Promise;
}




// require('velocity-animate');
// require('velocity-animate/velocity.ui');
render(
   <App />,
   document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js